import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { SectionHeading } from "../common/SectionHeading";
import { Reveal } from "../common/Reveal";
import { IMAGES } from "../../lib/data";

const WayCard = ({ to, title, copy, image, tall = false, testid, delay = 0 }) => (
    <Reveal delay={delay} className={tall ? "md:col-span-2 md:row-span-2" : ""}>
        <Link to={to} data-testid={testid} className="group block h-full">
            <motion.div
                whileHover="hover"
                className={`relative overflow-hidden rounded-3xl bg-ink h-full ${tall ? "min-h-[320px] md:min-h-[560px]" : "min-h-[240px] md:min-h-[268px]"}`}
            >
                <motion.img
                    src={image}
                    alt={title}
                    loading="lazy"
                    variants={{ hover: { scale: 1.06 } }}
                    transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
                    className="absolute inset-0 h-full w-full object-cover opacity-70"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />
                <div className="absolute inset-x-0 bottom-0 p-6 md:p-8 flex items-end justify-between gap-4">
                    <div>
                        <h3 className="font-oswald uppercase text-white text-3xl md:text-4xl leading-none">{title}</h3>
                        <p className="mt-2 text-sm text-zinc-300 max-w-xs">{copy}</p>
                    </div>
                    <span className="shrink-0 h-12 w-12 rounded-full bg-pink text-ink flex items-center justify-center transition-transform duration-300 group-hover:rotate-45">
                        <ArrowUpRight size={20} />
                    </span>
                </div>
            </motion.div>
        </Link>
    </Reveal>
);

export const ThreeWays = () => (
    <section data-testid="three-ways-section" className="bg-white py-24 md:py-32">
        <div className="mx-auto max-w-[1440px] px-5 md:px-10">
            <SectionHeading
                chapter="01"
                kicker="The Paths"
                title="Three Ways to Showtime"
                copy="Book it. Shop it. Stock it. Your way to Showtime starts here."
                testid="three-ways-heading"
            />
            <div className="grid gap-5 md:grid-cols-3">
                <WayCard
                    to="/book"
                    title="Book The Show"
                    copy="Events, parties and activations — spun fresh on-site."
                    image={IMAGES.girlTreat}
                    tall
                    testid="way-book-card"
                />
                <WayCard
                    to="/shop"
                    title="Shop The Fun"
                    copy="Cotton candy, popcorn, multipacks and party packs."
                    image={IMAGES.packaged}
                    testid="way-shop-card"
                    delay={0.1}
                />
                <WayCard
                    to="/wholesale"
                    title="Stock Showtime"
                    copy="Wholesale ordering for retailers."
                    image={IMAGES.wholesale}
                    testid="way-wholesale-card"
                    delay={0.2}
                />
            </div>
        </div>
    </section>
);
